<template>
  <article>
    <flightSegmentDetail
      class="flightDetails"
      :segmentDetail="segmentStopDetail"
      v-for="(segmentStopDetail, index) in segmentDetail.stops_details" :key="index"
      :connectionTime="index === 0 ? segmentDetail.connection_time : undefined"
      :main-flight-info="{
        familyFare: segmentDetail.family_fare,
        flightNumber: segmentDetail.flight_number,
        couponStatus: segmentDetail.coupon_status,
        carrierCode: segmentDetail.carrier_code,
        plane: segmentDetail.plane
      }"
      isStopDetail
    >
    </flightSegmentDetail>

    <div class="flightDetails__segmentGraphLine"></div>
    <div class="flightDetails__segment" v-if="isStopDetail || !segmentDetail.stops_details.length">
      <div class="flightDetails__segmentMessage"
        v-if="segmentDetail.connection_time">
        <div class="flightDetails__segmentMessageContainer">
          <div class="flightDetails__segmentMessageIcon">
            <i class="fas fa-exchange-alt"></i>
          </div>
          <div class="flightDetails__segmentMessageGroup">
            <span>{{ $t('shopping_lib.connection') }}</span>
            <!-- <span><b>Cambio de avión</b></span> -->
            <div class="flightDetails__segmentMessageTime">
              {{ segmentDetail.connection_time }} h
            </div>
          </div>
        </div>
      </div>

      <div class="flightDetails__segmentContainer">
        <div class="flightDetails__segmentOD">
          <div class="flightDetails__segmentAirport">
            <span class="flightDetails__segmentLabel">{{
              segmentDetail.departure?.date | dateFilter
            }}</span>
            <div class="flightDetails__segmentCodeTime">
              <span class="flightDetails__airport">{{
                segmentDetail.departure?.airport_reference_id
              }}</span>
              <i class="fas fa-plane-departure"></i>
              <span class="flightDetails__time">{{
                segmentDetail.departure?.time | timeFilter
              }}</span>
            </div>
            <span class="flightDetails__city">{{
              segmentDetail.departure?.location_city_name
            }}</span>
            <span class="flightDetails__location">{{
              segmentDetail.departure?.location_name
            }}</span>
          </div>

          <div class="flightDetails__segmentAirport">
            <span class="flightDetails__segmentLabel">{{
              segmentDetail.arrival?.date | dateFilter
            }}</span>
            <div class="flightDetails__segmentCodeTime">
              <span>{{ segmentDetail.arrival?.airport_reference_id }}</span>
              <i class="fas fa-plane-departure"></i>
              <span>{{ segmentDetail.arrival?.time | timeFilter }}</span>
            </div>
            <span class="flightDetails__city">{{
              segmentDetail.arrival?.location_city_name
            }}</span>
            <span class="flightDetails__location">{{
              segmentDetail.arrival?.location_name
            }}</span>
          </div>
        </div>

        <div class="flightDetails__segmentGraph">
          <div class="flightDetails__segmentGraphIcon">
            <i class="fas fa-user-circle"></i>
          </div>
          <div class="flightDetails__segmentGraphIcon">
            <i class="fas fa-map-marker-alt"></i>
          </div>
        </div>
        <div class="flightDetails__segmentInfo">
          <div class="flightDetails__segmentInfoFlight">
            <i class="fas fa-plane-departure mr-2"></i>
            {{ carrierCodeAndFlightNumber }}
          </div>
          <span>{{ $t(familyFare) }}</span>
          <span>
            {{ $t('operated_by') }}
            <b> {{ segmentDetail.operating_carrier }}</b>
          </span>
          <span>
            {{ $t('equipment_' + plane) }}
          </span>
          <div class="flightDetails_line"></div>
          <span>{{ $t('shopping_lib.flight_time') }}</span>
          <div class="flightDetails__segmentDuration">
            <span
              ><i class="fas fa-clock mr-2"></i>
              <b>{{ flightDuration | minutesFormatPipe }}</b></span
            >
          </div>
        </div>
      </div>

      <div class="flightDetails__segmentMessage" v-if="isStopDetail && segmentDetail.ground_time">
        <div class="flightDetails__segmentMessageContainer">
          <div class="flightDetails__segmentMessageIcon">
            <i class="fas fa-plane-arrival"></i>
          </div>
          <div class="flightDetails__segmentMessageGroup">
            <span class="flightDetails__segmentMessageGroup--layover"> {{ $t('stop') }} {{segmentDetail.arrival?.location_city_name?.toLowerCase()}}</span>
            <span><b>{{ $t('waiting_time') }}</b></span>
            <div class="flightDetails__segmentMessageTime">
              {{segmentDetail.ground_time | minutesFormatPipe}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
import moment from 'moment'
import filters from '../../helpers/filters'

export default {
  name: 'flightSegmentDetail',
  mixins: [filters],
  props: {
    segmentDetail: {
      type: Object,
      required: true,
    },
    connectionTime: {
      type: String,
      required: false,
    },
    mainFlightInfo: {
      type: Object,
      required: false,
    },
    isStopDetail: {
      type: Boolean,
      required: false,
    },
  },
  filters: {
    timeFilter(time) {
      return `${moment(time, 'HH:mm:ss').format('HH:mm')} h`
    },
    dateFilter(date) {
      return moment(date).format('DD MMM YYYY')
    },
  },
  computed: {
    haveStops: function () {
      return this.stops > 0
    },
    carrierCodeAndFlightNumber: function () {
      return this.isStopDetail ? `${this.mainFlightInfo.carrierCode}${this.mainFlightInfo?.flightNumber}`
      : `${this.segmentDetail.carrier_code}${this.segmentDetail.flight_number}`
    },
    carrierCode: function () {
      return this.isStopDetail ? `${this.mainFlightInfo?.carrierCode}`
      : `${this.segmentDetail?.carrier_code}`
    },
    familyFare: function () {
      return this.isStopDetail ? this.mainFlightInfo.familyFare : this.segmentDetail.family_fare
    },
    flightDuration: function () {
      return this.isStopDetail ? this.segmentDetail.flight_time : this.segmentDetail.journey_duration 
    },
    plane: function () {
      return this.isStopDetail ? this.mainFlightInfo.plane : this.segmentDetail.plane
    }
  },
}
</script>
<style lang="sass" scoped>

.flightDetails__segment
  display: flex
  flex-direction: column
.flightDetails__segmentContainer
  margin: 2rem 0
  display: flex
  z-index: 2
.flightDetails__segmentOD
  flex: 1
.flightDetails__segmentAirport
  display: flex
  flex-direction: column
  text-align: right
  &:last-child
    transform: translateY(calc(100% - 2rem))
.flightDetails__segmentInfo
  text-align: left
  flex: 1
  display: flex
  flex-direction: column
.flightDetails__segmentGraphIcon
  display: flex
  min-height: 2rem
  min-width: 2rem
  margin: 0 1rem
  align-items: center
  justify-content: center
  border-radius: 50%
  font-size: var(--font-size-md)
  background-color: var(--color-surface)
  color: var(--color-primary)
.flightDetails__segmentGraph
  display: flex
  justify-content: space-between
  flex-direction: column
.flightDetails__segmentGraphLine
  display: flex
  width: 2px
  height: calc(60% - 6rem)
  background: var(--color-primary)
  margin: 0 auto
  z-index: 1
  position: absolute
  left: 0
  right: 0
.flightDetails__segmentCodeTime
  display: flex
  justify-content: flex-end
  font-size: var(--font-size-smd)
  font-weight: 700
  align-items: center
  span
    margin: 0 .5rem
  i
    font-size: var(--font-size-sm)
.flightDetails__segmentDuration
  display: flex
  align-items: center
  justify-content: center
  border-radius: var(--b-radius-d1)
  padding: 0 0.5rem
  width: fit-content
  border: 1px solid var(--color-warning)
.flightDetails__segmentInfo
  display: flex
  flex-direction: column
  align-self: center
.flightDetails__segmentInfoFlight
  font-weight: bolder
  color: var(--color-primary)
  font-size: var(--font-size-sbase)
  display: flex
  align-items: center
  margin-bottom: 0.25rem
.flightDetails__segmentInfoFF
  background-color: var(--color-primary)
  color: var(--color-onPrimary)
  border-radius: var(--b-radius-sm)
  font-size: var(--font-size-xs)
  padding: 0 .25rem
  margin-left: .5rem
  text-transform: uppercase
.flightDetails__segmentInfoEquip
  font-weight: bolder
.flightDetails__segmentInfoAmenities
  display: flex
  color: var(--color-primary)
  margin: .5rem 0
  flex-flow: row wrap
  gap: .5rem
.flightDetails__segmentInfoAmenity
  height: 1.75rem
  width: 1.75rem
  display: flex
  align-items: center
  justify-content: center
  background-color: var(--color-overlay-05)
  border-radius: var(--b-radius-md)
  i
    opacity: .4
  &:hover
    i
      opacity: 1
.flightDetails__segmentLabel
  text-transform: uppercase
  font-size: var(--font-size-sm)
  font-weight: bolder
  opacity: .4
.flightDetails__segmentMessage
  display: flex
  justify-content: center
  background-color: var(--color-surface)
  position: relative
  z-index: 2
  width: 100%
  max-width: 300px
  margin: 5rem auto 3rem
.flightDetails__segmentMessageTime
  color: var(--color-success)
  font-weight: bolder
.flightDetails__segmentMessageContainer
  display: flex
  justify-content: center
  align-items: center
  background-color: var(--color-overlay-02)
  border-radius: var(--b-radius-md)
  width: 100%
  padding: 0.5rem 0
  margin: 0.5rem 0
  border: 1px solid var(--color-warning)
.flightDetails__segmentMessageGroup
  display: flex
  flex-direction: column
.flightDetails__segmentMessageGroup--layover
  text-transform: capitalize
.flightDetails__segmentMessageIcon
  margin-right: 1rem
  background-color: var(--color-overlay-05)
  border-radius: 50%
  height: 3rem
  padding: 0
  width: 3rem
  display: flex
  align-items: center
  justify-content: center
  font-size: var(--font-size-md)

.flightDetails__city
  color: var(--color-primary)
  font-size: var(--font-size-sbase)
  font-weight: 600
.flightDetails__location
  color: var(--color-onSurface)
  font-size: var(--font-size-sbase)

.flightDetails_line
  display: flex
  width: 50%
  align-items: center
  gap: 1rem
  color: var(--color-primary)
  margin-bottom: 0.5rem
  margin-top: 0.5rem
  &:after
    content: ''
    width: auto
    flex: 1
    height: 1px
    background-color: var(--color-primary)
    opacity: .3
    order: 2

@media (max-width: 418px)
  .flightDetails__segmentCodeTime
    span
      margin: 0rem
      margin-left: .1rem
</style>
